import { IModalDescription } from '@cp/shared/modal';
import type { DeleteProfileModalLayoutProps } from '../ui/deleteProfileModalLayout';

export const PROFILE_DELETE_MODAL: IModalDescription<DeleteProfileModalLayoutProps> = {
  nss: 'profile-delete',
  loader: () => import('../ui/deleteProfileModalLayout').then((module) => module.DeleteProfileModalLayout),
};
